








































































































































































import {Component, Prop, Vue} from 'vue-property-decorator'
import {AvailableIconsArray, AvailableIcons} from './models'

@Component
export default class IconCustom extends Vue {
  @Prop() readonly name!: AvailableIcons | string
  @Prop() readonly fill?: string
  @Prop() readonly size?: string
  @Prop({ default: false }) readonly mapped?: boolean

  private map: Object = {
    travel_type: 'case',
    budget: 'wallet',
    tourist: 'person',
    duration_days: 'calendar',
    category: 'star',
    locations: 'location'
  }

  private mapIcon(name: string): string {
    let res = name;
    Object.keys(this.map).forEach((label: string) => {
      if (name === label) {
        res = (this.map as any)[label];
      }
    });
    return res || name;
  }

  get iconName(): AvailableIcons {
    let icon = this.name;
    if (this.mapped && this.map) {
      icon = this.mapIcon(icon);
    }
    return (AvailableIconsArray.map((item: string) => item).indexOf(icon) === -1 ? 'star' : icon) as AvailableIcons;
  }

}
